<script setup>
import {useThemeComposable} from 'lxvue3'

import imgPath from '../assets/404_v2.png'

const {vertical} = useThemeComposable()
</script>

<template>
  <div class="lx-component-root-no-scroll relative">
    <div class="absolute top-0 left-0 bottom-0 right-0 flex flex-col" :class="[vertical ? 'top-[61px]':'top-0']">

      <div class="lx-content-scroll-container lx-content-no-scrolling lx-content-container basis-full flex flex-col rounded" id="lx-content-scroll-container">
        <img :src="imgPath" class="my-auto mx-auto"/>
      </div>

    </div>
  </div>
</template>
